import { useCallback, useMemo } from 'react';

import { type BaseCustomField } from '@air/api/types';

import { usePublicLibraryCustomFields } from '~/components/v2/hooks/usePublicLibraryCustomFields';

export type UsePublicGetAvailableCustomFields = {
  libraryId?: string;
};

export const usePublicGetAvailableCustomFields = <Data extends BaseCustomField>({
  libraryId,
}: UsePublicGetAvailableCustomFields) => {
  const { data: libraryCustomFields } = usePublicLibraryCustomFields({ libraryId });

  const getAvailableCustomFields = useCallback(
    (customFields?: Data[]) => {
      return libraryCustomFields?.data.length
        ? customFields?.filter(
            (customField) => !!libraryCustomFields?.data.find((field) => field.id === customField.id)?.visible,
          )
        : customFields;
    },
    [libraryCustomFields?.data],
  );

  const hasHiddenCustomFields = useMemo(() => {
    return libraryCustomFields?.data.some((field) => !field.visible);
  }, [libraryCustomFields?.data]);

  return {
    getAvailableCustomFields,
    hasHiddenCustomFields,
    libraryCustomFields,
  };
};
